import { storableError } from '../../util/errors';
import { shopifyAuthorize } from '../../util/api';

// ================ Action types ================ //

export const SHOPIFY_AUTH_REQUEST = 'app/ShopifyAuthorizePage/SHOPIFY_AUTH_REQUEST';
export const SHOPIFY_AUTH_SUCCESS = 'app/ShopifyAuthorizePage/SHOPIFY_AUTH_SUCCESS';
export const SHOPIFY_AUTH_ERROR = 'app/ShopifyAuthorizePage/SHOPIFY_AUTH_ERROR';

// ================ Reducer ================ //

const initialState = {
  loginInProgress: false,
  loginError: null,
  authCode: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SHOPIFY_AUTH_REQUEST:
      return { ...state, loginInProgress: true, loginError: null, authCode: null };
    case SHOPIFY_AUTH_SUCCESS:
      return { ...state, loginInProgress: false, authCode: payload.code };
    case SHOPIFY_AUTH_ERROR:
      return { ...state, loginInProgress: false, loginError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const shopifyAuthRequest = () => ({ type: SHOPIFY_AUTH_REQUEST });
export const shopifyAuthSuccess = code => ({ type: SHOPIFY_AUTH_SUCCESS, payload: { code } });
export const shopifyAuthError = error => ({
  type: SHOPIFY_AUTH_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const submitShopifyAuth = ({ email, password, shop, redirectUri }) => dispatch => {
  dispatch(shopifyAuthRequest());

  return shopifyAuthorize({ email, password, shop, redirect_uri: redirectUri })
    .then(response => {
      dispatch(shopifyAuthSuccess(response.code));
      return response;
    })
    .catch(e => {
      dispatch(shopifyAuthError(storableError(e)));
    });
};
